module.exports = __webpack_public_path__ + "static/Roboto-ThinItalic-2cbc2256ef5afbf04c18beeee4478e55.ttf";